/*
  Place to put line-item related helpers unique to this application.
  Code here is intended to be more testable than the lineItem related directives.
*/
import _ from 'lodash';

export default __filename;
angular
  .module(__filename, [])

  .factory(
    'lineItemService',
    ngInject(() => ({
      /*
    Reorders a single line item form instance and updates the numbers of surrounding line item form objects.

    @param  {Array}  lineItemForms  a list of line item form instances
    @param  {Object} lineItemForm   the subject to be reordered
    @param  {Number} desiredNumber  the new number
    */
      reorder(lineItemForms, lineItemForm, desiredNumber) {
        const currentNumber = lineItemForm.number;
        if (currentNumber === desiredNumber) {
          return;
        }
        const firstAffectedNumber = Math.min(currentNumber + 1, desiredNumber);
        const lastAffectedNumber = Math.max(currentNumber - 1, desiredNumber);
        const affectedLineItemForms = _(lineItemForms)
          .filter(({number}) => firstAffectedNumber <= number && number <= lastAffectedNumber)
          .sortBy(({number}) => number)
          .value();
        lineItemForm.number = desiredNumber;
        for (let index = 0; index < affectedLineItemForms.length; index++) {
          const affectedLineItemForm = affectedLineItemForms[index];
          const adjustedNumber = Math.min(currentNumber, desiredNumber + 1) + index;
          affectedLineItemForm.number = adjustedNumber;
        }
      },
    })),
  );
